import { Promise } from '@ambita/ambita-components-core';

declare global {
  interface Window { AMBITA_CONFIG: any; }
}

export interface EnvConfig {
  environment: string;
  isNorgesEiendommerNewEnabled?: boolean;
  isAdvancedRegistrationFlowEnabled?: boolean;
  isAdvancedCreditCardRegistrationFlowEnabled?: boolean;
}

export const fetchConfig = function (): Promise<EnvConfig> {
  return Promise.resolve(window.AMBITA_CONFIG);
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./app/config/envConfig.ts